<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BPR6x6/images/cover.jpg?1700571411011" alt="This image is the cover for the book Camel Pilot Supreme"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Camel Pilot Supreme
      </h1>
      <p class="bookDescription body article font2">
        <b>“Annette Carson has done a wonderful job of chronicling Armstrong’s life, flight training and ultimate recognition as the undisputed master of aerobatics.” —</b><b><i>Over the Front</i></b> <br/>  <br/> Initially forbidden as foolhardy, stunt flying soon became a paramount method of survival in the life and death mêlées of dogfighting. But pilots still delighted in the joy and exuberance of aerobatting for its own sake, and they recognized a master of that very special skill in young D’Urban Victor Armstrong, whose displays were nothing short of electrifying. Fluid and dramatic, performed with flair at ultra-low level, his exhibitions left spectators shaking their heads in disbelief.<br/>  <br/> Until this book, little was known about Armstrong’s wartime experiences, and even less about his South African background. His great value to the authorities lay in his superb handling of the Sopwith Camel, which upon its introduction had taken a heavy toll in fatal trainee accidents. While still on active service, Armstrong was sent around the units providing vivid proof that, properly handled, the stubby little fighter delivered the key to combat success: unrivaled maneuverability. His resultant fame eclipsed his other distinguished role in pioneering night flying and night fighting, an equally vital skill he was also detailed to demonstrate around the squadrons.<br/>  <br/> In this “superb biography,” you will find yourself in the cockpit of the F.1 Camel and become acquainted with its rotary engine (<i>Stand To!</i>). You will meet many leading names including Billy Bishop, Cecil Lewis, Norman Macmillan, Robert Smith Barry, and the harum-scarum Three Musketeers from <i>War Birds</i>. Armstrong takes his place alongside them as one of the legendary figures of the first great aerial war.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Annette Carson
      </h2>
      
      <p class="authorDescription body article">Annette Carson has written on a variety of nonfiction topics with a preference for history and biography. Her love of aviation led to involvement in aerobatics, a subject on which she has contributed to Encyclop&aelig;dia Britannica. She has served in organizational roles including Contest Director, British Team Manager and International Jury member, was an active delegate to the International Aerobatics Commission of the FAI, and in 1986 published Flight Fantastic: The Illustrated History of Aerobatics, earning the FAI&rsquo;s Tissandier Diploma. She won the 2019 Thornton B. Hooper Award of the League of WW1 Aviation Historians. Carson is also widely respected for her revisionist books and articles on Richard III. She was a founding member of the historical research team that mounted the search for his grave in Leicester and commissioned the archaeological dig that found him in 2012.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Air World
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3976aa03